import React, { FunctionComponent } from 'react';
import { Article, PageWrapper } from 'components/presentional';
import { getArticleTerms, useRouteTranslations } from 'utils';
import { Redirect, useParams } from 'react-router-dom';
import { usePosts } from 'hooks';
import { WPAcfBlog } from 'types/acf';
import { WPSimpleArticle } from 'types/articles';
import { CustomArticleSlugTypes } from 'types/global';

interface OwnProps {}

type ArticlePageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const ArticlePage: FunctionComponent<ArticlePageProps> = props => {
  const OFFERS_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'join_us';
  const { articleId } = useParams<any>();
  const { translateSlug } = useRouteTranslations();
  const translatedOffersSlug = translateSlug(OFFERS_PAGE_SLUG_TYPE);
  const { data: post, loading } = usePosts<WPSimpleArticle<WPAcfBlog>>({ slug: articleId });
  const [postData] = post || [];

  if (!articleId || (postData && postData.status === 'draft')) {
    return <Redirect to={translateSlug('not_found')} />;
  }

  const renderArticle = (article: WPSimpleArticle<WPAcfBlog>) => {
    const { _embedded } = article;
    const terms = getArticleTerms(_embedded);
    const { category: categories = [] } = terms;

    if (categories.find(category => category.slug === 'webinar')) {
      return <Redirect to={`/webinars/${articleId}`} />;
    }

    if (categories.find(category => category.slug === 'ebook')) {
      return <Redirect to={`/ebooks/${articleId}`} />;
    }

    if (categories.find(category => category.slug === 'case_study')) {
      return <Redirect to={`/case_studies/${articleId}`} />;
    }

    if (categories.find(category => category.slug === 'offer')) {
      return <Redirect to={`/${translatedOffersSlug}/${articleId}`} />;
    }

    return <Article data={article} />;
  };

  return (
    <PageWrapper title={postData?.yoast_title} meta={postData?.yoast_meta} loading={loading} name={OFFERS_PAGE_SLUG_TYPE}>
      {postData && !loading && renderArticle(postData)}
    </PageWrapper>
  );
};

export default ArticlePage;
